import React, { useState } from "react";

const ThemeSort = ({ selectedValue, handleChange, options }) => {
  return (
    <div className="theme-sort d-flex align-items-center gap-2">
      <span className="m-0 p-0">Sort by:</span>
      <div className="sort-container">
        <select
          className={`sort-dropdown ${
            selectedValue === 1 ? "default" : "highlight"
          }`}
          value={selectedValue}
          onChange={handleChange}
        >
          {options?.map((dt) => (
            <option value={dt?.value} key={dt?.value}>
              {dt?.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ThemeSort;
